<template>
  <div>
    <a-button type="primary" class="primary" size="small" @click="showBox">
      {{ $t("businessDispatch.uploadContainerSealNumber") }}
    </a-button>
    <a-modal
      :title="$t('businessDispatch.uploadContainerSealNumber')"
      :visible="visible_box"
      :confirm-loading="confirmLoading_box"
      @cancel="cancelBox"
      :destroyOnClose="true"
      width="800px"
    >
      <template>
        <a-form
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 19 }"
          class="upload-seal-form"
        >
          <a-form-item :label="$t('businessDispatch.containerNumber')" :required="true">
            <a-input
              v-model.trim="form_upload.containerNumber"
              :placeholder="$t('exampleText', { text: 'TCNU2085688' })"
              v-decorator="[
                'note',
                {
                  rules: [{ required: true, message: 'Please input your note!' }],
                },
              ]"
            />
            <template>
              <div>
                <BaseUpload
                  :file-list="fileList_xh"
                  :max-file="1"
                  @change="handleUploadChangeXH"
                  @remove="(file) => deleteImg('CONTAINER_IMAGE', file.uid)"
                  @preview="(file) => previewImg(fileList_xh, file)"
                />
                <!-- <a-upload
                  :customRequest="uploadFiles_xh"
                  @change="change_xh"
                  :beforeUpload="beforeUpload"
                  list-type="picture-card"
                  :file-list="fileList_xh"
                  :remove="(file) => deleteImg('CONTAINER_IMAGE', file.uid)"
                  @preview="(file) => previewImg(fileList_xh, file)"
                >
                  <div v-if="fileList_xh.length < 1" style="width: 500px">
                    <a-icon type="plus" />
                    <div class="ant-upload-text" style="font-size: 12px">
                      {{ $t("businessDispatch.uploadBoxDoorPhotoText") }}
                    </div>
                  </div>
                </a-upload> -->
              </div>
            </template>
          </a-form-item>
          <a-form-item :label="$t('businessDispatch.sealNumber')">
            <a-input
              v-model.trim="form_upload.containerSeal"
              :placeholder="$t('exampleText', { text: 'EMCRFX8818' })"
              v-decorator="[
                'note',
                {
                  rules: [{ required: true, message: 'Please input your note!' }],
                },
              ]"
            />

            <template>
              <div>
                <BaseUpload
                  :file-list="fileList_fh"
                  :max-file="1"
                  @change="(option) => handleUploadChange(option, 'SEAL_IMAGE')"
                  @remove="(file) => deleteImg('SEAL_IMAGE', file.uid)"
                  @preview="(file) => previewImg(fileList_fh, file)"
                />
                <!-- <a-upload
                  accept="image/png, image/jpeg"
                  :customRequest="(options) => uploadImage(options, 'SEAL_IMAGE')"
                  list-type="picture-card"
                  :beforeUpload="beforeUpload"
                  :file-list="fileList_fh"
                  :remove="(file) => deleteImg('SEAL_IMAGE', file.uid)"
                  @preview="(file) => previewImg(fileList_fh, file)"
                >
                  <div v-if="fileList_fh.length < 1" style="width: 500px">
                    <a-icon type="plus" />
                    <div class="ant-upload-text" style="font-size: 12px">
                      <span v-if="isInport">{{
                        $t("businessDispatch.uploadSealingPhotoText")
                      }}</span>
                      <span v-else>{{ $t("businessDispatch.uploadSealphotoText") }}</span>
                    </div>
                  </div>
                </a-upload> -->
              </div>
            </template>
          </a-form-item>
          <a-form-item :label="$t('businessDispatch.eir')" class="not-required">
            <template>
              <div>
                <BaseUpload
                  :file-list="fileList_eir"
                  :max-file="9"
                  @change="(option) => handleUploadChange(option, 'EIR_IMAGE')"
                  @remove="(file) => deleteImg('EIR_IMAGE', file.uid)"
                  @preview="(file) => previewImg(fileList_eir, file)"
                />
                <!-- <a-upload
                  accept="image/png, image/jpeg"
                  :customRequest="(options) => uploadImage(options, 'EIR_IMAGE')"
                  list-type="picture-card"
                  :beforeUpload="beforeUpload"
                  :file-list="fileList_eir"
                  :remove="(file) => deleteImg('EIR_IMAGE', file.uid)"
                  @preview="(file) => previewImg(fileList_eir, file)"
                >
                  <div v-if="fileList_eir.length <= 10" style="width: 500px">
                    <a-icon type="plus" />
                    <div class="ant-upload-text" style="font-size: 12px">
                      <span>{{ $t("businessDispatch.uploadEirText") }}</span>
                    </div>
                  </div>
                </a-upload> -->
              </div>
            </template>
          </a-form-item>
          <a-form-item
            :label="$t('businessDispatch.containerImage')"
            class="not-required"
          >
            <template>
              <div>
                <BaseUpload
                  :file-list="fileList_openDoor"
                  :max-file="9"
                  @change="(option) => handleUploadChange(option, 'OPEN_DOOR_IMAGE')"
                  @remove="(file) => deleteImg('OPEN_DOOR_IMAGE', file.uid)"
                  @preview="(file) => previewImg(fileList_openDoor, file)"
                />
                <!-- <a-upload
                  accept="image/png, image/jpeg"
                  :customRequest="(options) => uploadImage(options, 'OPEN_DOOR_IMAGE')"
                  list-type="picture-card"
                  :beforeUpload="beforeUpload"
                  :file-list="fileList_openDoor"
                  :remove="(file) => deleteImg('OPEN_DOOR_IMAGE', file.uid)"
                  @preview="(file) => previewImg(fileList_openDoor, file)"
                >
                  <div v-if="fileList_openDoor.length <= 10" style="width: 500px">
                    <a-icon type="plus" />
                    <div class="ant-upload-text" style="font-size: 12px">
                      <span>{{ $t("businessDispatch.uploadContainerImage") }}</span>
                    </div>
                  </div>
                </a-upload> -->
              </div>
            </template>
          </a-form-item>
          <a-form-item
            :label="`${$t('businessDispatch.tareWeight')}(kg)`"
            v-if="!isInport"
          >
            <a-input
              :placeholder="$t('exampleText', { text: '3700' })"
              :maxLength="5"
              type="text"
              oninput="value=value.replace(/[^\d]/g,'')"
              v-model.trim="form_upload.containerTareWeight"
            ></a-input>
          </a-form-item>
          <a-form-item :label="$t('businessDispatch.pickUpTime')">
            <div style="float: left">
              <a-date-picker
                allowClear
                :locale="locale"
                :placeholder="$t('businessDispatch.selectDate')"
                :valueFormat="dateFormat"
                :format="monthFormat"
                v-model="defaultValueDate"
                :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
                style="width: 50%; margin-right: 10px"
                @change="changeDate"
              />
              <a-time-picker
                :minute-step="5"
                :placeholder="$t('businessDispatch.selectTime')"
                v-model="defaultValueTime"
                :format="showTime.format"
                style="width: 45%"
                @change="changeTime"
              />
            </div>
          </a-form-item>
        </a-form>
      </template>

      <template slot="footer" class="footer_paiche">
        <a-button
          key="submit"
          type="primary"
          :loading="confirmLoading_seal"
          @click="uploadFiles"
          class="avatar-uploader"
        >
          {{ $t("upload") }}
        </a-button>
        <a-button key="back" @click="cancelBox">
          {{ $t("cancel") }}
        </a-button>
      </template>
    </a-modal>

    <ImagePreview ref="imagePreviewRef" />
  </div>
</template>
<script>
import ImagePreview from "../ImagePreview";
import { searchReqParam } from "../../utils/searchReqParam";
import { compressImg } from "../../utils/compressImg";
import moment from "moment";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import BaseUpload from "@/components/base-upload";
import {
  uploadSeals,
  uploadContainerSealNo,
  reqcontainerSeal,
} from "../../api/business-dispatch";

export default {
  name: "upload-seal",
  components: { ImagePreview, BaseUpload },
  props: {
    selectedRows: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      defaultValueDate: moment(),
      defaultValueTime: moment(),
      locale,
      req: searchReqParam(),
      visible_box: false,
      confirmLoading_seal: false,
      confirmLoading_box: false,
      form_upload: {
        containerNumber: "",
        containerSeal: "",
        containerTareWeight: undefined,
        files: [],
        respDate: moment(),
      },
      fileList_xh: [],
      fileList_fh: [],
      fileList_eir: [],
      fileList_openDoor: [],
      bdstyle: {
        width: "1000px",
        height: "750px",
        color: "black",
      },
      truckList: [],
      driverList: [],
      isInport: false,
      rotateTimes: 0,
      multiples: 1,
      imgStyle: "",
      showTime: {
        format: "HH:mm",
        minuteStep: 5,
        defaultTime: moment(),
      },
      dateFormat: "YYYY-MM-DD",
      monthFormat: "YYYY-MM-DD",
    };
  },
  methods: {
    async handleUploadChangeXH({ file }) {
      const newFile = await this.beforeUpload(file);
      await this.uploadFiles_xh({ file: newFile });
    },

    async handleUploadChange({ file }, type) {
      const newFile = await this.beforeUpload(file);
      this.uploadImage({ file: newFile }, type);
    },
    // 预览照片
    previewImg(fileList, file) {
      console.log(fileList, "fileList");
      const list = fileList.map((f) => f.url || f.imgUrl);
      const index = fileList.findIndex((f) => f === file);
      this.$refs.imagePreviewRef.open(list, index);
    },
    // 上传箱封号
    showBox() {
      // 回显箱封照片
      if (this.selectedRows.length >= 1) {
        if (this.selectedRows[0].orderStatus.code == "CANCELLED") {
          this.$message.error(
            this.$t("billsReceivable.orderCanceledUnableToUploadBoxNumber")
          );
          return;
        }
        if (this.selectedRows[0].orderStatus.code != "DISPATCHED") {
          this.$message.warning(this.$t("billsReceivable.PleaseSendCarPrompt"));
          return;
        }
        console.log(this.selectedRows[0].boundType.code);
        if (this.selectedRows[0].boundType.code == "IB") {
          this.isInport = true;
        } else {
          this.isInport = false;
        }
        // 重构封箱号回显逻辑
        let params = {};
        params.containerId = this.selectedRows[0].containerId;
        this.req.params = params;
        reqcontainerSeal(this.req)
          .then((res) => {
            let tempData = JSON.parse(res.data);
            if (!tempData.success || tempData.code != "0") {
              return this.$message.error(tempData.msg);
            }
            let data = tempData.data;
            console.log("res ===== ", data);
            this.form_upload.containerNumber = data.containerNumber;
            this.form_upload.containerSeal = data.containerSeal;
            this.form_upload.containerTareWeight = data.containerTareWeight;
            if (data.feedbackTime) {
              this.defaultValueDate = moment(data.feedbackTime);
              this.defaultValueTime = moment(data.feedbackTime);
            } else {
              this.defaultValueDate = moment();
              this.defaultValueTime = moment();
            }

            data.files.forEach((item, index) => {
              // 箱号 CONTAINER_IMAGE
              if (item.fileType == "CONTAINER_IMAGE") {
                const imgItem = {
                  uid: index.toString(), // 注意，这个uid一定不能少，否则上传失败
                  name: "container",
                  status: "done",
                  url: item.url, // url 是展示在页面上的绝对链接
                  imgUrl: item.url, // imgUrl 是存到 db 里的相对链接
                  // response: '{"status": "success"}',
                };
                this.fileList_xh.push(imgItem);
              } else if (item.fileType == "SEAL_IMAGE") {
                // 封号 SEAL_IMAGE
                const imgItem = {
                  uid: index.toString(), // 注意，这个uid一定不能少，否则上传失败
                  name: "seal",
                  status: "done",
                  url: item.url, // url 是展示在页面上的绝对链接
                  imgUrl: item.url, // imgUrl 是存到 db 里的相对链接
                  // response: '{"status": "success"}',
                };
                this.fileList_fh.push(imgItem);
              } else if (item.fileType == "EIR_IMAGE") {
                // EIR 照片
                const imgItem = {
                  uid: index.toString(),
                  name: "eir",
                  status: "done",
                  url: item.url,
                  imgUrl: item.url,
                };
                this.fileList_eir.push(imgItem);
              } else if (item.fileType == "OPEN_DOOR_IMAGE") {
                // 箱况照
                const imgItem = {
                  uid: index.toString(),
                  name: "openDoor",
                  status: "done",
                  url: item.url,
                  imgUrl: item.url,
                };
                this.fileList_openDoor.push(imgItem);
              }
            });
            this.visible_box = true;
          })
          .catch((error) => {
            console.log(error);
            this.$message.error(this.$t("businessDispatch.failedToGetSealingNumber"));
          });
      } else {
        this.$message.error(this.$t("businessDispatch.feedbackTransportNode[0]"));
      }
    },
    cancelBox(e) {
      console.log(e);
      // 重置file列表
      this.fileList_xh = [];
      this.fileList_fh = [];
      this.fileList_eir = [];
      this.fileList_openDoor = [];
      this.visible_box = false;
    },
    changeDate(date, dateString) {
      this.defaultValueDate = date;
      console.log(date, dateString);
    },
    changeTime(time) {
      this.defaultValueTime = time;
      console.log(time);
    },
    // 移除照片
    deleteImg(type, uid) {
      switch (type) {
        case "CONTAINER_IMAGE":
          this.fileList_xh = this.fileList_xh.filter((item) => {
            return item.uid != uid;
          });
          break;
        case "SEAL_IMAGE":
          this.fileList_fh = this.fileList_fh.filter((item) => {
            return item.uid != uid;
          });
          break;
        case "EIR_IMAGE":
          this.fileList_eir = this.fileList_eir.filter((item) => {
            return item.uid != uid;
          });
          break;
        case "OPEN_DOOR_IMAGE":
          this.fileList_openDoor = this.fileList_openDoor.filter((item) => {
            return item.uid != uid;
          });
          break;
      }
    },
    // 请求 upload 接口生成箱号照片url
    async uploadFiles_xh(options) {
      console.log("options === ", options);
      // 查询文件是否存在
      //   const queryParam = {
      //     meta: {
      //       code: "",
      //       client: "",
      //       tag: "",
      //       time: "",
      //     },
      //     params: {
      //       bizType: "",
      //       tags: [""],
      //     },
      //   };
      //   let res = await queryFile(queryParam);
      //   console.log(res);

      // 封装请求数据
      const param = new FormData();
      const meta = {
        code: "seals_xh",
        client: "PC",
        tag: "seals_xh",
        time: Date.now(),
      };
      const params = {
        bizType: "seals_xh",
      };
      for (let key in meta) {
        param.append(`meta.${key}`, meta[key]);
      }
      for (let key in params) {
        param.append(`params.${key}`, params[key]);
      }

      param.append("params.files", options.file);
      //   let that = this;
      uploadSeals(param).then((res) => {
        // console.log(JSON.parse(res.data));
        let result = JSON.parse(res.data);
        if (result.code == "0") {
          // 成功
          const imgItem = {
            uid: Math.random().toString(36).substring(2, 15), // 注意，这个uid一定不能少，否则上传失败
            name: options.file.name,
            status: "done",
            url: result.data.filePaths[0], // url 是展示在页面上的绝对链接
            imgUrl: result.data.filePaths[0], // imgUrl 是存到 db 里的相对链接
          };
          this.fileList_xh.push(imgItem);
        } else {
          // 失败提示信息
          this.$message.error(result.msg);
        }
      });
    },
    //后期这几个工具方法剥离
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        if (!file.type.includes("image")) {
          this.$message.warning(this.$t("businessDispatch.pleaseUploadPictures"));
          reject(new Error(this.$t("businessDispatch.pleaseUploadPictures")));
          return;
        }
        // const newFile = await this.compressImg(file);
        // resolve(newFile);
        compressImg(file).then((res) => {
          console.log(res);
          resolve(res);
        });
      });
    },
    change_xh(options) {
      console.log(options);
    },
    // 请求 upload 接口生成封号url
    uploadImage(options, type) {
      console.log("options === ", options);
      // 封装请求数据
      const param = new FormData();
      const meta = {
        code: type,
        client: "PC",
        tag: type,
        time: Date.now(),
      };
      const params = {
        bizType: type,
      };
      for (let key in meta) {
        param.append(`meta.${key}`, meta[key]);
      }
      for (let key in params) {
        param.append(`params.${key}`, params[key]);
      }
      param.append("params.files", options.file);
      let that = this;
      uploadSeals(param).then((res) => {
        // console.log(JSON.parse(res.data));
        let result = JSON.parse(res.data);
        if (result.code == "0") {
          // 成功
          const imgItem = {
            uid: Math.random().toString(36).substring(2, 15), // 注意，这个uid一定不能少，否则上传失败
            name: options.file.name,
            status: "done",
            url: result.data.filePaths[0], // url 是展示在页面上的绝对链接
            imgUrl: result.data.filePaths[0], // imgUrl 是存到 db 里的相对链接
            // response: '{"status": "success"}',
          };
          switch (type) {
            // case 'CONTAINER_IMAGE':
            // 	that.fileList_xh.push(imgItem);
            // 	break;
            case "SEAL_IMAGE":
              that.fileList_fh.push(imgItem);
              break;
            case "EIR_IMAGE":
              that.fileList_eir.push(imgItem);
              break;
            case "OPEN_DOOR_IMAGE":
              that.fileList_openDoor.push(imgItem);
              break;
          }
        } else {
          // 失败提示信息
          this.$message.error(result.msg);
        }
      });
    },
    // 确认上传箱封号和箱封照
    uploadFiles() {
      // console.log(this.form_upload);
      // 封装请求数据
      let params = {};
      // 箱号
      params.containerNumber = this.form_upload.containerNumber;
      // 封号
      params.containerSeal = this.form_upload.containerSeal;
      params.containerTareWeight = this.form_upload.containerTareWeight;
      // 日期
      params.feedbackTime =
        moment(this.defaultValueDate).format("YYYY-MM-DD") +
        " " +
        moment(this.defaultValueTime).format("HH:mm");
      console.log(params.feedbackTime);

      // 文件信息
      const fileList_xh_imgs = this.fileList_xh.map((item) => ({
        fileType: "CONTAINER_IMAGE",
        url: item.url,
      }));
      const fileList_fh_imgs = this.fileList_fh.map((item) => ({
        fileType: "SEAL_IMAGE",
        url: item.url,
      }));
      const fileList_eir_imgs = this.fileList_eir.map((item) => ({
        fileType: "EIR_IMAGE",
        url: item.url,
      }));
      const fileList_openDoor_imgs = this.fileList_openDoor.map((item) => ({
        fileType: "OPEN_DOOR_IMAGE",
        url: item.url,
      }));
      this.form_upload.files = [
        ...fileList_xh_imgs,
        ...fileList_fh_imgs,
        ...fileList_eir_imgs,
        ...fileList_openDoor_imgs,
      ];
      if (
        this.form_upload.files.find((item) => item.fileType === "CONTAINER_IMAGE") &&
        this.form_upload.files.find((item) => item.fileType === "SEAL_IMAGE")
      ) {
        params.files = this.form_upload.files;
      } else {
        this.$message.error(this.$t("businessDispatch.numberAndBoxSealPhotoMessage"));
        return;
      }
      if (this.defaultValueDate == "" || this.defaultValueDate == null) {
        this.$message.error(this.$t("businessDispatch.feedbackDateCannotBeEmpty"));
        return;
      }
      if (this.defaultValueTime == "" || this.defaultValueTime == null) {
        this.$message.error(this.$t("businessDispatch.feedbackDateCannotBeEmpty"));
        return;
      }
      // 订单ID
      params.orderId = this.selectedRows[0].orderId;
      // 箱子ID
      params.containerId = this.selectedRows[0].containerId;

      this.req.params = params;

      this.confirmLoading_box = true;
      if (!params.containerNumber || params.containerNumber.trim() == "") {
        this.$message.error(this.$t("businessDispatch.boxNumberCannotBeEmpty"));
        return;
      }
      if (!params.containerSeal || params.containerSeal.trim() == "") {
        this.$message.error(this.$t("businessDispatch.sealNumberCannotBeEmpty"));
        return;
      }
      if (
        this.selectedRows[0].boundType.code == "OB" &&
        (params.containerTareWeight == null || params.containerTareWeight == "")
      ) {
        return this.$message.error(this.$t("businessDispatch.pleaseFillInTheTareWeight"));
      }
      uploadContainerSealNo(this.req).then((res) => {
        // console.log(JSON.parse(res.data));
        let result = JSON.parse(res.data);
        if (result.code == "0") {
          // 成功提示信息
          this.$message.success(result.msg);
          // 重置
          this.visible_box = false;
          this.form_upload = {
            containerNumber: "",
            containerSeal: "",
            containerTareWeight: undefined,
            files: [],
          };
          this.fileList_xh = [];
          this.fileList_fh = [];
          this.fileList_eir = [];
          this.fileList_openDoor = [];
          this.confirmLoading_box = false;
          // 通知父单元成功消息
          this.$emit("success", result.msg);
        } else {
          // 失败提示信息
          this.$message.error(result.msg);
        }
      });
    },
    // 旋转图片
    rotateLeft() {
      // this.$refs.imageBox.style.transform =
      // 	"rotate(" + 90 * this.rotateTimes + "deg)";
      this.rotateTimes++;
      this.imgStyle = `transform: rotate(${90 * this.rotateTimes}deg) scale(${
        this.multiples
      })`;
      console.log(this.imgStyle);
    },
    // 放大
    toBIgChange() {
      if (this.multiples >= 2) {
        return;
      }
      this.multiples += 0.25;
      this.imgStyle = `transform: rotate(${90 * this.rotateTimes}deg) scale(${
        this.multiples
      })`;
    },
    // 缩小
    toSmallChange() {
      if (this.multiples <= 1) {
        return;
      }
      this.multiples -= 0.25;
      this.imgStyle = `transform: rotate(${90 * this.rotateTimes}deg) scale(${
        this.multiples
      })`;
    },
    // 实现图片拖拽
    imgMove(e) {
      this.cleanUpDefaultEvent(e);
      console.log("e", e.clientX, e.target.offsetLeft);
      let oImg = e.target;
      let disX = e.clientX - oImg.offsetLeft;
      let disY = e.clientY - oImg.offsetTop;
      document.onmousemove = (e) => {
        e.preventDefault();
        let left = e.clientX - disX;
        let top = e.clientY - disY;
        this.imgStyle = this.imgStyle + `left: ${left}px; top:${top}px;`;
      };
      document.onmouseup = () => {
        document.onmousemove = null;
        document.onmousemove = null;
      };
    },
    cleanUpDefaultEvent(event) {
      event = event || window.event || arguments.callee.caller.arguments[0];
      if (event.preventDefault) {
        //IE not have
        event.preventDefault();
      }
      event.returnValue = false;
    },
  },
};
</script>
<style lang="less">
.upload-seal-form {
  .ant-form-item-children .ant-upload-select-picture-card {
    height: 80px;
  }
}
</style>

<style lang="less" scoped>
/deep/ .dialogClass {
  height: 80% !important;
  width: 60% !important;
}

/deep/.dialogClass .ant-modal-content {
  .ant-modal-close {
    height: 6%;
    width: 50px;
    display: flex;
    justify-content: center;
    align-items: center;

    .ant-modal-close-x {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .ant-modal-header {
    height: 6%;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ant-modal-body {
    height: 88%;
    overflow: hidden;

    .ant-pagination-simple .ant-pagination-simple-pager input:nth-child(1) {
      width: 40px;
    }
  }

  .ant-modal-footer {
    height: 6%;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .ant-btn {
      font-size: 12px;
    }
  }

  .imgStyle {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    cursor: pointer;
  }
}

/deep/ .ant-row .ant-form-item {
  // align-items: start;
  background-color: black;
}

.attactment-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
}

.attachment-footer {
  height: 6%;
  position: relative;
  display: flex;
  align-items: center;
  background: #c7c5c5;
  font-weight: bold;
}

/deep/.ant-form-item-label > label::before {
  content: "*";
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
  color: red;
}

/deep/.not-required .ant-form-item-label > label::before {
  content: "";
}
</style>
